var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeciality10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.d,.g{fill:none;}.c,.d,.e{stroke:#208ce1;stroke-width:1.5px;}.c{stroke-linecap:round;}.f{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-457 -7656)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(457 7656)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.428 0.979)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-443.541-7620.674s-11.388-9.8-2.866-17.2c6.939-7.391,2.036-8.673,7.089-11.841s15.914-5.807,20.74.98,1.508,16.215,1.508,16.215"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-442.184-7630.166s-1.569-6.667,3.53-9.707,8.726-.784,10.883-6.275"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-425.81-7648.7s8.236,3.333,4.9,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-440.419-7638.157s1.373,14.167,10.295,15.442"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-449.572-7611.538s.247-7.438,7.615-6.51,6.441-7.51,6.441-7.51"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-431 -7635)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 9,
    cy: 9,
    r: 8.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-415.878-7619.725l3.972,3.749"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality10);
export default __webpack_public_path__ + "static/media/speciality10.103eaf3e1b5f820aaea0360c2fc09fd0.svg";
export { ForwardRef as ReactComponent };